// extracted by mini-css-extract-plugin
export default {"container":"BinaryFileEditor_container__iki2H","mediaContainer":"BinaryFileEditor_mediaContainer__0ltpI","image":"BinaryFileEditor_image__kZlSW"};